import {
  initialAgreementListAdditionalFields,
  isTestAdditionalField,
} from '../constants/initialAgreementListAdditionalFields';
import { IAgreementListFilter } from '../interfaces/IAgreementListFilter';
import { IAgreementListFilterExtraField } from '../interfaces/IAgreementListFilterField';

export function mapFilterAdditionalFields(isUserTest: boolean) {
  return (filter: IAgreementListFilter): IAgreementListFilterExtraField[] => {
    let items = initialAgreementListAdditionalFields;

    if (isUserTest && !initialAgreementListAdditionalFields.find(i => i.id === isTestAdditionalField.id)) {
      items = [...initialAgreementListAdditionalFields, isTestAdditionalField];
    }

    return items.map<IAgreementListFilterExtraField>(field => {
      switch (field.id) {
        case 'isTest': {
          return {
            ...field,
            isSelected: Boolean(filter.isTest),
          };
        }
        case 'executionAgreementDateBetween': {
          return {
            ...field,
            isSelected:
              (filter.executionAgreementDateBetweenStart && filter.executionAgreementDateBetweenStart.length > 0) ||
              (filter.executionAgreementDateBetweenEnd && filter.executionAgreementDateBetweenEnd.length > 0) ||
              false,
          };
        }
        case 'subjectInn': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectInn),
          };
        }
        case 'objectOgrn': {
          return {
            ...field,
            isSelected: Boolean(filter.objectOgrn),
          };
        }
        case 'subjectOrgName': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectOrgName),
          };
        }
        default:
          return field;
      }
    });
  };
}
